import React from 'react'
import { Typography } from "@mui/material"

export function ListItem({ bulletColor="tertiary", color="text.primary", children, variant="body1", fontWeight, ...props }) {
  return (
    <Typography variant={variant} color={bulletColor} component="li" {...props}>
      <Typography component="span" variant={variant} color={color} fontWeight={fontWeight}>{children}</Typography>
    </Typography>
  )
}

export default ListItem